<div class="html-overflow">
  <div class="w-h-label html-overflow" *ngIf="withLabel">
    {{ label | translate }}
  </div>
  <div
    class="default-value html-overflow"
    style="display: block"
    [matTooltip]="customerName()"
  >
    {{ customerName() }}
  </div>
</div>
